// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"18":"24d59d48","642":"dfd60053","751":"544a3bb3"}[chunkId] + ".js";
};